export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7788.2ed92c10.jpg";